import React from 'react';
import { FaUserPlus, FaUserCheck } from 'react-icons/fa';

const PatientTypeSelector = ({ patientType, setPatientType }) => (
  <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
    <label className="inline-flex items-center cursor-pointer">
      <input
        type="radio"
        className="form-radio text-blue-600 hidden"
        name="patientType"
        value="new"
        checked={patientType === "new"}
        onChange={() => setPatientType("new")}
      />
      <span className={`px-4 py-2 rounded-full flex items-center ${patientType === "new" ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}>
        <FaUserPlus className="mr-2" />
        New Patient
      </span>
    </label>
    <label className="inline-flex items-center cursor-pointer">
      <input
        type="radio"
        className="form-radio text-blue-600 hidden"
        name="patientType"
        value="recurring"
        checked={patientType === "recurring"}
        onChange={() => setPatientType("recurring")}
      />
      <span className={`px-4 py-2 rounded-full flex items-center ${patientType === "recurring" ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}>
        <FaUserCheck className="mr-2" />
        Recurring Patient
      </span>
    </label>
  </div>
);

export default PatientTypeSelector;